import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_emoji-5",
  "use": "svg_emoji-5-usage",
  "viewBox": "0 0 28 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 25\" id=\"svg_emoji-5\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M27.3 11.02h-4.504v4.596H.7v4.523h22.096v4.596h4.503V11.02ZM6.012 3.134a2.673 2.673 0 1 1-5.347 0 2.673 2.673 0 0 1 5.347 0Zm21.32 0a2.673 2.673 0 1 1-5.346 0 2.673 2.673 0 0 1 5.346 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol